// store/resetAction.js
import { createAction } from '@reduxjs/toolkit';

export const resetStore = createAction('reset/store'); // Clear all the store

export const resetErrorSlice = createAction('reset/errorSlice'); // Clear Error Slice
